//
//  src/components/enquire/EnquireOutcomeError.js
//
import * as React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushContactError } from "../google/Google";
import "./EnquireOutcome.css";

const IconError = () => (
    <svg viewBox="0 0 60 60" width="80" height="80">
        <circle cx="30" cy="30" r="28" stroke="currentColor" strokeWidth="2.5" fill="none" />
        <path
            d="M22 22 L38 38 M38 22 L22 38"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
        />
    </svg>
);

export default function EnquireOutcomeError({
    source = "form",
    title = "Server Error",
    subtitle = "Enquiry Not Received",
    message,
    secondary,
}) {
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.data && typeof location.state.files === "number") {
            pushContactError(source, location.state.data, location.state.files).catch((error) => {
                console.error("pushContactError:", error);
            });
        }
    }, [location.state, source]);

    return (
        <div className="contact-outcome-shell">
            <div className="contact-outcome contact-error">
                <div className="contact-outcome-icon error" aria-hidden="true">
                    <IconError />
                </div>
                <h1>{title}</h1>
                <h4>{subtitle}</h4>
                {message}
                {secondary && <p className="contact-outcome-secondary">{secondary}</p>}
            </div>
        </div>
    );
}
